import {
  geoProvider
} from "./chunk-LM2PYTEN.mjs";
import {
  userIdProvider
} from "./chunk-S6V4GUYU.mjs";
import {
  installIdProvider
} from "./chunk-IHVH5I36.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-WNQUEZJF.mjs";

// src/initializers/initialize.ts
import { initialize as coreInitialize } from "@youversion/analytics-core";
function initialize(config, callback) {
  const _a = config, { providers } = _a, rest = __objRest(_a, ["providers"]);
  coreInitialize(
    __spreadProps(__spreadValues({
      relatedDomains: ["youversion.com", "bible.com", "thewardro.be"]
    }, rest), {
      providers: __spreadValues({ geoProvider, installIdProvider, userIdProvider }, providers)
    }),
    callback
  );
}

export {
  initialize
};
